import { createContext, useContext } from "react";

const LoginContext = createContext<{
  email: string | null;
  /**
   * TODO: Make this be `string` instead of `number`
   */
  userId: number | null;
}>({
  email: null,
  userId: null,
});

export const useLoginContext = () => {
  return useContext(LoginContext);
};

export const LoginContextProvider = (props: {
  email: string | null;
  /**
   * TODO: Make this be `string` instead of `number`
   */
  userId: number | null;
  children: React.ReactNode;
}) => {
  return (
    <LoginContext.Provider
      value={{
        email: props.email,
        userId: props.userId,
      }}
    >
      {props.children}
    </LoginContext.Provider>
  );
};
